import {
    HANDLE_GET_STATE_RESPONSE,
    SET_LOADING_BAR,
    SET_SERVER_TIME_OFFSET,
    SET_SERVER_TIME_ZONE_OFFSET
} from '../constants/actionTypes';
import {isLocalStorageAvailable} from '../helpers/systemHelpers';
import {getItem, setItem} from "../helpers/localStorageHelpers";
import {UNREAD_BETS} from '../constants/localStorage';
import {UPDATE_PLAYER_BALANCE} from './../constants/actionTypes';
import {DISABLED_VIRTUALS, VIRTUALS} from "../constants/games";

export function handleGetStateResponse(response, playerUID, isPlaceBetResponse = false) {
    // this is a fallback, if no lastLogoffDate is passed, we assume the current date minus one day
    if (!response.lastLogoffDate) {
        response.lastLogoffDate = new Date();
        response.lastLogoffDate = response.lastLogoffDate.getTime() - (86400000);
    }
    let onLoad = false;
    if (isLocalStorageAvailable) {
        if (response.playerUID !== undefined) {
            playerUID = response.playerUID;
        }

        let localBets = getItem(playerUID, UNREAD_BETS);
        let isFirstTimeLoad = false;
        // local storage returns null is the object does not exist
        if (localBets === null) {
            isFirstTimeLoad = true;
            localBets = {
                placedBets: [],
                settledBets: [],
            };
        }

        if (response.RecentBets && response.RecentBets.length) {
            response.RecentBets = response.RecentBets.filter((sBets) => VIRTUALS.find(game => game.channel === sBets.Bets[0].Channel) || DISABLED_VIRTUALS.find(dGame => dGame.channel === sBets.Bets[0].Channel));
        }

        if (response.OpenBets && response.OpenBets.length) {
            localBets.placedBets = response.OpenBets.filter((sBets) => VIRTUALS.find(game => game.channel === sBets.Bets[0].Channel) || DISABLED_VIRTUALS.find(dGame => dGame.channel === sBets.Bets[0].Channel));
//      localBets.placedBets = response.OpenBets.filter((pBets) => pBets.Bets.filter((bet) => {
//        let existingLocalBet = getExistingLocalBet(bet, localBets.placedBets);
//        if ((existingLocalBet === undefined || bet.isRead === undefined || existingLocalBet.isRead === true)) {
//          if (existingLocalBet !== undefined && existingLocalBet.isRead === true) {
//            pBets.isRead = true;
//          }
//          return true;
//        }
//        return false;
//      }).length > 0);
        } else {
            localBets.placedBets = [];
        }
        if (response.RecentBets && response.RecentBets.length) {
            localBets.settledBets = localBets.settledBets.concat(response.RecentBets.filter((sBets) => {
                let existingLocalBet = getExistingLocalBet(sBets, localBets.settledBets);
                return existingLocalBet === undefined;
            }));
        }

        localBets.playerWasNotified = localBets.settledBets.find((sb) => sb.isRead === false || sb.isRead === undefined) !== undefined
        && !isFirstTimeLoad
            ? false
            : true;

        if (isFirstTimeLoad) {
            onLoad = true;
            localBets.settledBets.map((sb, index) => {
                //setting true while first time loading.
                sb.isRead = true;
                sb.isFlashed = true;
            });
        }

        localBets.isPlaceBetResponse = isPlaceBetResponse;

        setItem(playerUID, UNREAD_BETS, playerUID !== undefined ? localBets : {placedBets: [], settledBets: []});
    }

    // sort bets by event time
    let newPlacedBets = sortLockedBets(response.OpenBets.filter((sBets) => VIRTUALS.find(game => game.channel === sBets.Bets[0].Channel) || DISABLED_VIRTUALS.find(dGame => dGame.channel === sBets.Bets[0].Channel)));
    let newSettledBets = sortLockedBets(response.RecentBets.filter((sBets) => VIRTUALS.find(game => game.channel === sBets.Bets[0].Channel) || DISABLED_VIRTUALS.find(dGame => dGame.channel === sBets.Bets[0].Channel)));

    return {
        type: HANDLE_GET_STATE_RESPONSE,
        placedBets: newPlacedBets,
        settledBets: newSettledBets,
        playerUID: response.playerUID,
        isPlaceBetResponse,
        Balance: response.Balance,
        isFirstTimeLoad: onLoad
    };
}

function getExistingLocalBet(bet, localBets) {
    let opaqueData = JSON.parse(bet.Bets[0].OpaqueData);
    let uniqueId = opaqueData.uniqueId;
    if (bet && bet.Bets && bet.Bets.length && localBets && localBets.length) {
        return localBets.find((lb) => {
            return JSON.parse(lb.Bets[0].OpaqueData).uniqueId === uniqueId;
        });
    }
}

function sortLockedBets(lockedBets) {
    lockedBets = lockedBets.sort((a, b) => {
        // find the earliest date of the entire bet (accounts for multiple)
        let firstBetDateTime;
        a.Bets.map((bet) => {
            if (firstBetDateTime === undefined || firstBetDateTime > bet.EventTime) {
                firstBetDateTime = bet.EventTime;
            }
            return bet;
        });

        let secondBetDateTime;
        a.Bets.map((bet) => {
            if (secondBetDateTime === undefined || secondBetDateTime > bet.EventTime) {
                secondBetDateTime = bet.EventTime;
            }
            return bet;
        });

        return firstBetDateTime - secondBetDateTime;
    });
    return lockedBets;
}

export function setServerTimeOffset(offset) {
    return {type: SET_SERVER_TIME_OFFSET, offset};
}

export function setLoadingBar(loadingBarPercentage) {
    return {type: SET_LOADING_BAR, loadingBarPercentage};
}

export function updatePlayerBalance(balance, playerUID = null) {
    return {type: UPDATE_PLAYER_BALANCE, playerBalance: balance, playerUID: playerUID};
}

export function setServerTimeZoneOffset(serverTimeZoneOffset) {
    return {type: SET_SERVER_TIME_ZONE_OFFSET, serverTimeZoneOffset};
}


// WEBPACK FOOTER //
// ./src/actions/platformActions.js